
var colors = {
    gray: '#DDD',
    blue: '#0E4070',
    red: '#D0021B',
};


module.directive('dial', function(numberFilter) {
    return {
        restrict: 'E',
        template: '<donut-chart data="data" colors="colors" ticks="ticks" text="{{ text }}"></donut-chart>',
        scope: {value: '=', color: '=', standard: '=', average: '=', naText: '@'},
        link: function(scope, element, attrs) {

            scope.colors =  ['#DDD', '#DDD'];
            scope.data = [0, 100];

            scope.ticks = [
                {type: 'line', value: 0, class: 'standard'},
                {type: 'triangle', value: 0, class: 'average'},
            ];

            scope.$watchGroup(['value', 'color', 'standard', 'average'], function(values) {
                scope.text = angular.isNumber(values[0]) ? numberFilter(values[0], 0) + "%" : (scope.naText || '');
                scope.data[0] = numberFilter(values[0] || 0, 0);
                scope.data[1] = 100 - scope.data[0];
                scope.colors[0] = getColor(values[0], values[1]) || '#DDD';
                scope.ticks[0].value = (values[2] || 0) / 100;
                scope.ticks[1].value = (values[3] || 0) / 100;
            });

            function getColor(value, color) {
                if (!angular.isNumber(value)) return colors.gray;
                if (color && color[0] === '#') return color;
                return colors[color] || colors[attrs.color] || colors.blue;
            };
        }
    }
});

function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}

module.directive('reportBar', function($timeout) {
    return {
        restrict: 'E',
        templateUrl: 'util/widgets/reportBar',
        scope: {report: '=', max: '=', name: '@'},
        link: function(scope, element, attrs) {

            scope.innerWidth = 0;
            scope.outerWidth = 100;
            scope.text = "";
            scope.color = colors.blue;

            function getColor(value) {
                var color = scope.report.getColor(scope.name);
                if (!angular.isNumber(value)) return colors.gray;
                // if (scope.name) return colors.blue;
                if (color && color[0] === '#') return color;
                return colors[color] || colors[attrs.color] || colors.blue;
            };

            scope.$watch('report.getPercent(name)', function(percent) {
                $timeout(function() {
                    scope.innerWidth = clamp(percent || 0, 10, 100);
                    scope.text = angular.isNumber(percent) ? Math.round(percent) + "%" : "N/A";
                    scope.color = getColor(percent);
                    element.toggleClass('negative', angular.isNumber(percent) && percent < 0);
                    element.toggleClass('positive', angular.isNumber(percent) && percent > 0);
                });
            });

            scope.$watch('max', function(max) {
                $timeout(function() {
                    var denom = scope.report.getDenominator(scope.name);
                    denom = Math.log(denom);
                    max = Math.log(max);
                    scope.outerWidth = clamp(denom * 100 / max, 10, 100);
                    console.log(scope.outerWidth);
                });
            });
        },
    };
});


module.directive('reportBarHover', function() {
    return {
        restrict: 'E',
        templateUrl: 'util/widgets/reportBarHover',
        scope: {report: '=', name: '@', max: '=', noun: '@',
                numeratorText: '@', denominatorText: '@',
                percentText: '@'}
    }
});

module.directive('reportIconHover', function() {
    return {
        restrict: 'E',
        templateUrl: 'util/widgets/reportIconHover',
        transclude: true,
        scope: {report: '=', name:'@', icon:'@', src:'@'},
        link: function(scope, element, attrs) {
            scope.color = colors[scope.name ? 'blue' : 'green'];
        }
    };
});


module.directive('dybLogBar', ['$timeout', function($timeout) {
    return {
        restrict: 'E',
        templateUrl: 'reports/dybLogBar',
        scope: {max: '=', num: '=', denom: '=', useLog: '=', label: '=?'},
        link: function(scope, element, attrs) {

            var loaded = false;

            scope.scale = 100;
            scope.percent = 0;
            scope.rounded = "";

            function scaleBar(num, denom, max, useLog) {

                if (angular.isUndefined(num) || angular.isUndefined(denom)) {
                    scope.scale = 100;
                    scope.percent = 0;
                    scope.rounded = "";
                    return;
                }

                if (denom == 0) {
                    scope.percent = 100;
                    scope.scale = 0;
                    scope.rounded = "N/A";
                    return;
                }

                scope.percent = Math.min(num / denom * 100, 100);
                scope.rounded = Math.round(scope.percent) + "%";
                if (!attrs.label) {
                    scope.label = scope.rounded;
                }

                if (angular.isDefined(attrs.max) && angular.isDefined(max)) {
                    if (!scope.useLog) {
                        scope.scale = Math.log(denom) / Math.log(max) * 100;
                    } else {
                        scope.scale = denom / max * 100;
                    }
                } else {
                    scope.scale = 100;
                }
                scope.scale = clamp(scope.scale, 10, 100);
            }

            scope.$watchGroup(['num', 'denom', 'max', 'useLog'], function(newVals) {
                if (loaded) {
                    scaleBar.apply(this, newVals);
                } else {
                    loaded = true
                    $timeout(function() {
                        scaleBar.apply(this, newVals);
                    }, Math.random() * 500);
                }
            });
        }
    }
}]);
